import Backbone from 'backbone'
import Format from '../helpers/result-text-format'

const AnswerModel = Backbone.Model.extend({
    defaults: {
        text: null,
        correct: false,
        selected: false,
        length: null,
    },
    initialize() {
        this.set('correct', this.get('correct') === '1')
        this.set('length', this.get('text').length)
        this.set('text', Format(this.get('text')))
    }
})

export default AnswerModel
